import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import ManageListEmbedded from '../ManageListEmbedded/ManageListEmbedded';
import Post from '../../../Data/Post';
import GeneralViewer from '../../General/GeneralViewer/GeneralViewer';
import CraftedRegionFactory from '../../Crafted/CraftedRegionFactory';
import ManageRecordDates from '../ManageRecord/ManageRecordDates';
import { PutButtonsIntoPassiveMode } from '../../../Utils/Forms/GetVisibleButtons';
import TopbarMenu from '../../General/TopbarMenu/TopBarMenu';
import PrintPreview from '../PrintPreview/PrintPreview';
import { Separator } from '@fluentui/react';
import './ViewRecord.css';


const ViewRecord = (props) => {

    const [rxdItemId, setRxdItemId] = useState(props.itemId);
    const [itemId, setItemId] = useState(props.itemId);
    const [regionData, _setRegionData] = useState([]); const regionDataRef = useRef(regionData);
    const [displayMode, setDisplayMode] = useState("");

    const errorWhenRetrievingData = (response) => {
    }

    const setRegionData = data => {
        regionDataRef.current = data;
        _setRegionData(data);
    };

    const viewDataRetrievedSuccessfully = useCallback((data, index) => {

        ManageRecordDates(data);
        var newRegionData = [...regionDataRef.current];
        newRegionData[index] = {...data};
        setRegionData(newRegionData);

        // Issue query for next standard (non list-view) region, if there is one.
        var currentView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        var resultantItemId = itemId;
        if (props.itemId !== rxdItemId) {
            setItemId(props.itemId);
            setRxdItemId(props.itemId);
            resultantItemId = props.itemId;
        }

        if (currentView !== null && currentView.Regions.length > (index + 1) && currentView.Regions[index + 1].QueryName !== '') {
            const criteria = { Name: currentView.Regions[index + 1].QueryName, Parameters: [{ Key: 'id', Value: resultantItemId }] };
            Post('query/filteredget', criteria, viewDataRetrievedSuccessfully, errorWhenRetrievingData, index + 1);
        }
    }, [rxdItemId, itemId, props.itemId, props.recordviews, props.type]);

    useEffect(() => {
        var newView = props.recordviews.filter((view) => {
            return view.Name === props.type;
        })[0];

        if (newView !== null && newView.Regions.length > 0 && newView.Regions[0].QueryName !== '') {
            const criteria = { Name: newView.Regions[0].QueryName, Parameters: [{ Key: 'id', Value: itemId }]};
            Post('query/filteredget', criteria, viewDataRetrievedSuccessfully, errorWhenRetrievingData, 0);
        }
    }, [props.recordviews, props.type, viewDataRetrievedSuccessfully, itemId]);

    const getListView = (listViewName) => {
        return props.views.filter((view) => {
            return view.Name === listViewName;
        })[0];
    }

    const clickButtonHandler = (button, id, recordInfo) => {
        const action = props.uievents.filter(a => a.Name === button.UIEvent);
        if (action[0].Type === 'printpreview')
        {
            const newDisplayMode = displayMode == "printpreview" ? "normal" : "printpreview";
            setDisplayMode(newDisplayMode)
        }
    }

    const buttonClickHandler = (button) => {
        clickButtonHandler(button, itemId);
    }

    // Set correct view config for record type.
    var viewConfig = props.recordviews.filter((view) => {
        return view.Name === props.type;
    })[0];

    for (var region of viewConfig.Regions) {
        if (region.Type === 'listview' && region.ListViewName !== '') {
            region.ListView = getListView(region.ListViewName);
        }
    }

    let visibleButtons = PutButtonsIntoPassiveMode(viewConfig.Buttons);
    const passive = visibleButtons.length == 0;

    let mainContent;
    if (displayMode == "printpreview") {
        mainContent = <PrintPreview id={itemId} reportConfiguration={props.reportConfiguration}></PrintPreview>
    } else {
        mainContent = (
            <div className='viewrecord-content'>
                {viewConfig.Regions.map((region, index) => {

                    switch (region.Type) {
                        case "standard":
                            if (regionData[index] !== undefined) {
                                return (<GeneralViewer key={region.Id} data={regionData[index]} language={props.language}></GeneralViewer>)
                            } else return (null) 
                        case "listview":
                            return (
                                <div key={region.Id}>
                                    {region.Title !== undefined && region.Title !== '' ? (
                                        <div className='viewrecord-sectiontitle'>
                                            {region.Title}
                                        </div>
                                    ) : (null)}
                                    <div>
                                        <ManageListEmbedded
                                            config={region.ListView}
                                            parentId={region.ListView.ParentId}
                                            itemId={itemId}
                                            toggleFullScreen={false}
                                            region={index}
                                            refresh={false}
                                            passive={true}>
                                        </ManageListEmbedded>
                                    </div>
                                </div>
                            )
                        case "crafted":
                            return(
                                <div key={region.Id}>
                                    {region.Title !== undefined && region.Title !== '' ? (
                                    <div className='viewrecord-sectiontitle'>
                                        {region.Title}
                                    </div>
                                    ) : (null)}
                                    <div className='viewrecord-section-table'>
                                        <CraftedRegionFactory
                                            config={region}
                                            region={index}
                                            refresh={false}
                                            passive={true}
                                            language={props.language}
                                            id={itemId}>
                                        </CraftedRegionFactory>
                                    </div>
                                </div>
                                
                            )
                        default: return (null)
                    }
                })}
            </div>
        );
    }

    const topBarMenu = <TopbarMenu
        suppressFarItems={true}
        showFilterIcon={false}
        displayGridView={false}
        buttons={visibleButtons}
        language={props.language}
        clickButton={buttonClickHandler}>
    </TopbarMenu>

    return (
        <div className='viewrecord-page'>
            <div className='viewrecord-titlebar'>
                <div className='viewrecord-title'>
                    {viewConfig.Title}
                    {passive !== true ? (
                            <div>
                                {topBarMenu}
                                <div className='managerecord-topbar-separator'>
                                    <Separator></Separator>
                                </div>
                            </div>
                        ) : (null)}
                </div>
            </div>
            {mainContent}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        currentView: state.display.currentView,
        views: state.config.views,
        recordviews: state.config.recordviews,
        uievents: state.config.uievents,
        forms: state.config.forms,
        pages: state.config.pages,
        lists: state.config.lists,
        language: state.config.language
    };
}

export default connect(mapStateToProps)(ViewRecord);
